'use strict';

var $ = require('jquery');
var progress = require('../utils/progress');
var validInputIndicator = require('../validation/valid-input-indicator');
var captcha = require('../spam/captcha');

const highlightTermsError = $newsletterContainer => {
    const $acceptTerms = $newsletterContainer.find('.accept-terms');
    $acceptTerms.find('.custom-checkbox-container').addClass('error');
    $acceptTerms.find('.checkbox-input').one('click', e => {
        $newsletterContainer
            .parent()
            .find('.status')
            .fadeOut(300, () => $(e.currentTarget).siblings('.custom-checkbox-container').removeClass('error'));
    });
};

const showTermsError = $newsletterContainer => {
    const message = $newsletterContainer.data('terms-not-accepted-msg');
    $('<div class="status message error-form">' + message + '</div>').insertBefore($newsletterContainer);
    highlightTermsError($newsletterContainer);
};

const handleSubscribe = ($form, $actionElement) => {
    if (!$form.valid()) {
        return false;
    }
    $form.parent().find('.status').remove();
    const hasAcceptedTerms =
        $form.find('.js-accept-terms-hidden').length > 0
            ? true
            : $form.find('.accept-terms .checkbox-input').prop('checked');

    if (!hasAcceptedTerms) {
        showTermsError($form);
        return;
    }

    const url = $form.attr('action');
    const email = $form.find('input.input-email').val();
    const gender = $actionElement.attr('value');
    const $genderInput = $form.find('.newsletter-gender');
    if ($genderInput.length) {
        $genderInput.val(gender);
    }

    progress.show($('.nlsubscribe-form-container'));
    $.ajax({
        url: url,
        type: 'POST',
        dataType: 'json',
        data: $form.serialize(),
        success: data => {
            if (data.success) {
                $form.replaceWith('<div class="status message success-form">' + data.msg + '</div>');

                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'newsletterSignup_page',
                        newsletterSignupStep: 'NewsletterSignupPage'
                    });
                }

                if (data.additionalText) {
                    $('.success-form').append(data.additionalText);
                }
            } else if (data.valueError) {
                $('<div class="status message error-form">' + data.valueError + '</div>').insertBefore($form);

                if (data.termsError) {
                    highlightTermsError($form);
                }
                captcha.resetCaptcha($form[0]);
            }
        },
        error: err => {
            $('<div class="status message error-form">' + Resources.NEWSLETTER_ERROR + '</div>').insertBefore($form);
            captcha.resetCaptcha($form[0]);
        },
        complete: () => progress.hide()
    });
};

exports.init = () => {
    const $subscribeForm = $('.nlsubscribe-form-container .nlsubscribe-form');
    $subscribeForm.find('button[type="button"], input[type="submit"]').on('click', e => {
        e.preventDefault();
        handleSubscribe($subscribeForm, $(e.currentTarget));
    });

    validInputIndicator.initValidIndicatorEvent({container: $subscribeForm});
};
